/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { projectsDeleteById } from "../funcs/projectsDeleteById.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  DeleteProjectRequest,
  DeleteProjectSecurity,
} from "../models/operations/deleteproject.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type DeleteProjectMutationVariables = {
  request: DeleteProjectRequest;
  security?: DeleteProjectSecurity | undefined;
  options?: RequestOptions;
};

export type DeleteProjectMutationData = void;

export type DeleteProjectMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * deleteProject projects
 *
 * @remarks
 * Delete a project by its ID
 */
export function useDeleteProjectMutation(
  options?: MutationHookOptions<
    DeleteProjectMutationData,
    DeleteProjectMutationError,
    DeleteProjectMutationVariables
  >,
): UseMutationResult<
  DeleteProjectMutationData,
  DeleteProjectMutationError,
  DeleteProjectMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildDeleteProjectMutation(client, options),
    ...options,
  });
}

export function mutationKeyDeleteProject(): MutationKey {
  return ["@gram/client", "projects", "deleteById"];
}

export function buildDeleteProjectMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: DeleteProjectMutationVariables,
  ) => Promise<DeleteProjectMutationData>;
} {
  return {
    mutationKey: mutationKeyDeleteProject(),
    mutationFn: function deleteProjectMutationFn({
      request,
      security,
      options,
    }): Promise<DeleteProjectMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(projectsDeleteById(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
